import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { ExpandingWildsBulkFactory, ExpandingWildsBulk, ExpandingWildsBulkParam, ExpandingWildsBulkConfig } from "../../slot/ExpandingWildBulk";
import { Rect } from "../.././MyHelpers";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
//namespace SlotGames {
export class ChilliBlast_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {


	protected override helpFactory: IHelpFactory = new ChilliBlastHelpFactory();
	protected override expandingWildsFactory: ExpandingWildsBulkFactory = new ChilliBlastExpandingWildsBulkFactory();

	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "ChilliBlast");
		this.spinnableReelsParams.topBorderWidth = 0;
		this.spinnableReelsParams.bottomBorderWidth = 0;
	}

	// public PrepareFont(resourceManager: ResourceManager)
	// {
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
	// }
	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "white",
			coloroutherStroke: "black",
			colorinnerStroke: "red",
		}

	protected override colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg,  rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

}

//Help Colorized
class ChilliBlastHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new ChilliBlastHelp(params);
	}
}

class ChilliBlastHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(64,23,8),rgb(115,62,31), rgb(115,62,31),rgb(115,62,31),rgb(64,23,8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}

class ChilliBlastExpandingWildsBulkFactory extends ExpandingWildsBulkFactory {
	public override CreateExpandingWildsBulk(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig): ExpandingWildsBulk {
		return new ChilliBlastExpandingWildsBulk(param, config);
	}

}

class ChilliBlastExpandingWildsBulk extends ExpandingWildsBulk {
	public override InflateWildSize(wildRect: Rect): Rect {
		return wildRect;
	}
}

//}
